/*
 * @Author: mazhigang
 * @Date: 2023-07-03 15:10:18
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-10-26 11:42:37
 */
/*
 * @Author: mazhigang
 * @Date: 2023-07-03 15:10:18
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-07-15 16:46:27
 */
function phone(num) {
  if (!num) {
    num = 0;
  }
  num = num.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
  return num;
}
function moneyFormat(num) {
  if (!num) {
    num = 0;
  }
  num = parseFloat((num + "").replace("/[^d.-]/g", "")).toFixed(2) + "";
  return num;
}
function addComma(num = 0) {
  return num.toString().replace(/\d+/, function(n) {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  });
}
function uniqueBy(arr, key) {
  const seen = new Map();
  const result = [];

  for (const item of arr) {
    const val = item[key];
    if (!seen.has(val)) {
      seen.set(val, true);
      result.push(item);
    }
  }

  return result;
}
function maxTime(min) {
  let minTime = "";
  if (min < 60) {
    minTime = min + "分钟";
  } else {
    let hour = Math.trunc(min / 60);
    if (hour < 24) {
      let middle = min - parseInt(hour * 60);
      if (middle == 0) {
        minTime = hour + "小时";
      } else {
        minTime = hour + "小时" + middle + "分钟";
      }
    } else {
      let day = Math.trunc(min / 1440);
      hour = Math.trunc((min - 1440 * day) / 60);
      let middle = min - (1440 * day + 60 * hour);
      if (middle == 0 && hour != 0) {
        minTime = day + "天" + hour + "小时";
      } else if (hour == 0) {
        minTime = day + "天";
      } else {
        minTime = day + "天" + hour + "小时" + middle + "分钟";
      }
    }
  }
  return minTime;
}
function maxTime1(time) {
  let h = parseInt((time / 60 / 60) % 24);
  h = h < 10 ? "0" + h : h;
  let m = parseInt((time / 60) % 60);
  m = m < 10 ? "0" + m : m;
  let s = parseInt(time % 60);
  s = s < 10 ? "0" + s : s;
  // 作为返回值返回
  return h + ":" + m + ":" + s;
}
function maskPhoneNumber(phoneNumber) {
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
}
// list   为3级菜单的预留   children为当前菜单下的页面
function indexData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  if (list.length != 0) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].url == "/index") {
        arr.push(list[i]);
      }
    }
  }
  return arr;
}
function systemData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/system") {
      arr = list[i].children;
    }
  }

  return arr;
}
function userData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/user") {
      arr = list[i].children;
    }
  }
  return arr;
}
function askariData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/askari") {
      arr = list[i].children;
    }
  }
  return arr;
}
function taskData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/task") {
      arr = list[i].children;
    }
  }
  return arr;
}
function operateData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/operate") {
      arr = list[i].children;
    }
  }
  return arr;
}
function financeData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/finance") {
      arr = list[i].children;
    }
  }

  return arr;
}
function taxData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/tax") {
      arr = list[i].children;
    }
  }

  return arr;
}
function customerData() {
  let list = JSON.parse(localStorage.getItem("rule")) || [];
  let arr = [];
  for (var i = 0; i < list.length; i++) {
    if (list[i].url == "/customer") {
      arr = list[i].children;
    }
  }

  return arr;
}
function areerList() {
  const arr = [
    {
      key: "所有",
      value: "0"
    },
    {
      key: "保安",
      value: "1"
    },
    {
      key: "消防中控",
      value: "2"
    },
    {
      key: "安检员",
      value: "3"
    }
  ];
  return arr;
}
function typeList() {
  const arr = [
    {
      key: "身高",
      value: "1"
    },
    {
      key: "性别",
      value: "2"
    },
    {
      key: "年龄",
      value: "3"
    },
    {
      key: "着装",
      value: "4"
    }
  ];
  return arr;
}
function levelList() {
  const arr = [
    {
      key: "资格证",
      value: "0"
    },
    {
      key: "初级(五级)",
      value: "1"
    },
    {
      key: "中级(四级)",
      value: "2"
    },
    {
      key: "高级(三级)",
      value: "3"
    },
    {
      key: "保安师(二级)",
      value: "4"
    },
    {
      key: "高级保安师",
      value: "5"
    }
  ];
  return arr;
}
export default {
  maxTime,
  phone,
  maxTime1,
  moneyFormat,
  addComma,
  indexData,
  systemData,
  userData,
  askariData,
  taskData,
  operateData,
  financeData,
  taxData,
  customerData,
  maskPhoneNumber,
  areerList,
  typeList,
  uniqueBy,
  levelList
};
